/** The lowest home value the original form's slider starts at. */
export const STARTING_HOME_VALUE_FLOOR = 150000;

/** FRU-24881: median_price answers with the median of the ZIP Cloudflare guesses from the visitor's connection (price), and
 *  now the state median too (state_price). A connection that maps to a low-value ZIP, or the wrong place, started the slider
 *  low. The slider starts at the highest of price, state_price and $150,000. A missing, zero or non-numeric field is skipped,
 *  so before the endpoint sends state_price this is the higher of price and $150,000. */
export function startingHomeValue(response: any): number {
  const amount = (v: any): number => {
    const n = Number(v);
    return isFinite(n) && n > 0 ? n : 0;
  };
  return Math.max(amount(response && response.price), amount(response && response.state_price), STARTING_HOME_VALUE_FLOOR);
}
